<template>
  <div>
    <el-dropdown @command="changeLanguage">
      <span class="el-dropdown-link">
        {{languageData[languageIndex].name}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="index" v-for="(item,index) in languageData" :key="index">{{item.name}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    computed: {
    	languageIndex() {
    		return this.$store.state.languageIndex
    	},
      languageData(){
        return this.$store.state.languageData
      }
    },
    methods: {
      changeLanguage(e){
        this.$store.commit('update',["languageIndex",e])
      }
    },
    mounted() {
    }
  };
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/language.vue